

import {
  FETCH_ATTENDANCE_STATUS_REQUEST,
  FETCH_ATTENDANCE_STATUS_SUCCESS,
  FETCH_ATTENDANCE_STATUS_FAILURE,
  CHECK_IN_REQUEST,
  CHECK_IN_SUCCESS,
  CHECK_IN_FAILURE,
} from "../actions/attendanceActions";

const initialState = {
  loading: false,
  attendanceStatus: null,
  checkInData: null,      // ✅ added to hold check-in response
  error: null,
};

export const attendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ATTENDANCE_STATUS_REQUEST:
    case CHECK_IN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ATTENDANCE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        attendanceStatus: action.payload,
        error: null,
      };

    case CHECK_IN_SUCCESS:
      return {
        ...state,
        loading: false,
        checkInData: action.payload, // ✅ storing check-in result
        error: null,
      };

    case FETCH_ATTENDANCE_STATUS_FAILURE:
    case CHECK_IN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
